import { Routes, Route } from "react-router-dom";

import LandingPage from "../src/Component/LandingPage";
function App() {
  return (
    <>
      {/* <Nav />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/venues" element={<VenuePage />} />
        <Route path="/venues/:city/:slug" element={<VenueDetailPage />} />
        <Route path="/rfp" element={<RFPPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes> */}
      <LandingPage />
    </>
  );
}

export default App;
